import * as d3 from "d3";
import { map } from "lodash";

export function avoidCollisions(x, r, max) {
    function box_force() { 
        for (var i = 0, n = d.length; i < n; ++i) {
            let curr_node = d[i];
            curr_node.x = Math.max(0, Math.min(max, curr_node.x));
        }
    }
    let d = map(x, x => ({x: x, y: 0, fy: 0}));
    let simulation = d3.forceSimulation(d)
        .force("collision", d3.forceCollide(r))
        .force("box", box_force)
        .stop();
    simulation.tick(30);
    return map(d, "x")
}